import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/explorer/real-state-management/page.tsx");
